<template>
  <el-table
    ref="table"
    :data="innerData"
    :height="height"
    :max-height="innerMaxHeight"
    :stripe="stripe"
    :border="border"
    :size="size"
    :fit="fit"
    :show-header="showHeader"
    :header-row-class-name="headerRowClassName"
    :header-row-style="headerRowStyle"
    :header-cell-class-name="headerCellClassName"
    :header-cell-style="headerCellStyle"
    :row-class-name="rowClassName"
    :row-style="rowStyle"
    :cell-class-name="cellClassName"
    :cell-style="cellStyle"
    :span-method="spanMethod"
    :highlight-current-row="highlightCurrentRow">
    <slot></slot>
  </el-table>
</template>

<script>
/**
 * ElTable の最低限のプロパティのみ定義しています
 * 必要があればElTableで定義しているプロパティ・イベントを適宜定義してラップしてください。
 * ElTableのdataプロパティについては、継承クラス側でgetterをオーバーライドして適当な値を
 * 返却するようにしてください。
 */
/* eslint-disable semi */
import { Component, Prop, Watch } from 'vue-property-decorator';
import SasComponent from './SasComponent';

@Component
export default class SasTable extends SasComponent {
  @Prop({require: false})
  data;

  @Prop({default: null})
  height;

  @Prop({default: null})
  maxHeight;

  @Prop({default: false})
  stripe;

  @Prop({default: false})
  border;

  @Prop()
  size;

  @Prop({default: true})
  fit;

  @Prop({default: true})
  showHeader;

  @Prop({default: false})
  highlightCurrentRow;

  @Prop({default: null})
  headerRowClassName;

  @Prop({default: null})
  headerRowStyle;

  @Prop({default: null})
  headerCellClassName;

  @Prop({default: null})
  headerCellStyle;

  @Prop({default: null})
  rowClassName;

  @Prop({default: null})
  rowStyle;

  @Prop({default: null})
  cellClassName;

  @Prop({default: null})
  cellStyle;

  @Prop({default: null})
  spanMethod;

  get innerData () {
    return this.data;
  }

  doLayout () {
    this.$refs.table.doLayout();
  }

  data () {
    return {
      innerMaxHeight: null
    }
  }

  @Watch('innerData', {immediate: true})
  onChangeData () {
    if (this.maxHeight != null) {
      this.innerMaxHeight = null;
      this.$nextTick().then(() => {
        this.innerMaxHeight = this.maxHeight;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/core/ui/SasTable.vue